<template>
  <v-app id="privacy-policy">
    <!-- Header -->
    <div class="privacy-header" :style="headerStyle">
      <div class="container">
        <div class="privacy-header__content">
          <v-btn icon small class="privacy-header__back" @click="goBack">
            <v-icon size="20" color="white">mdi-arrow-left</v-icon>
          </v-btn>
          <div>
            <h1 class="privacy-header__title">Politique de Confidentialité</h1>
            <p class="privacy-header__date">Date d'entrée en vigueur : 11/11/2025</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="container privacy-content" :style="contentStyle">
      <div class="privacy-card">
        <!-- Section 1 -->
        <section class="privacy-section">
          <h2 class="section-title">1. Introduction</h2>
          <p class="section-text">
            La présente Politique de Confidentialité a pour objectif d'informer les utilisateurs de l'application et du site web UrbanGO, ainsi que les compagnies de transport partenaires, sur la manière dont leurs données à caractère personnel sont collectées, traitées et protégées par la société UrbanGO.
          </p>
          <p class="section-text">
            UrbanGO est une société de droit ivoirien, représentée par son Gérant, Mohamed FADIGA, et dont le siège social est situé à Yopougon quartier Maroc, station Pétro Ivoire.
          </p>
          <p class="section-text">
            En tant que responsable de traitement, UrbanGO s'engage à respecter les dispositions de la Loi n° 2013-450 du 19 juin 2013 relative à la protection des Données à Caractère Personnel en Côte d'Ivoire.
          </p>
        </section>

        <!-- Section 2 -->
        <section class="privacy-section">
          <h2 class="section-title">2. Définitions Légales</h2>
          <p class="section-text">Selon la Loi n° 2013-450 :</p>
          
          <div class="privacy-table">
            <div class="table-row table-header">
              <div class="table-cell">Terme</div>
              <div class="table-cell">Définition selon la Loi n° 2013-450</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Donnée à caractère personnel</div>
              <div class="table-cell">Toute information relative à une personne physique identifiée ou qui peut être identifiée, directement ou indirectement.</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Traitement de données</div>
              <div class="table-cell">Toute opération ou ensemble d'opérations portant sur des données à caractère personnel (collecte, enregistrement, organisation, conservation, modification, etc.).</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Responsable du traitement</div>
              <div class="table-cell">La personne physique ou morale qui, seul ou conjointement avec d'autres, prend la décision de collecter et de traiter des données à caractère personnel.</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Autorité de protection</div>
              <div class="table-cell">L'Autorité de Régulation des Télécommunications/TIC de Côte d'Ivoire (ARTCI), chargée de veiller au respect de la Loi n° 2013-450.</div>
            </div>
          </div>
        </section>

        <!-- Section 3 -->
        <section class="privacy-section">
          <h2 class="section-title">3. Données Collectées et Finalités du Traitement</h2>
          <p class="section-text">
            UrbanGO collecte et traite les données à caractère personnel de ses utilisateurs pour des finalités déterminées, explicites et légitimes, conformément à l'article 14 de la Loi n° 2013-450.
          </p>

          <h3 class="subsection-title">3.1. Données des Clients (Acheteurs de Billets)</h3>
          <div class="privacy-table data-table">
            <div class="table-row table-header">
              <div class="table-cell">Catégorie de Données</div>
              <div class="table-cell">Finalité du Traitement</div>
              <div class="table-cell">Base Légale</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">
                Données d'identification<br>
                <span class="cell-detail">(Nom, Prénom, Téléphone, E-mail)</span>
              </div>
              <div class="table-cell">Gestion de la réservation, émission du billet, communication relative au voyage, service client.</div>
              <div class="table-cell">Exécution du contrat (Art. 14, al. 2)</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">
                Données de transaction<br>
                <span class="cell-detail">(Détails du voyage, Montant, Référence Wave)</span>
              </div>
              <div class="table-cell">Traitement du paiement, prélèvement des frais de réservation, comptabilité.</div>
              <div class="table-cell">Exécution du contrat et Intérêt légitime (Art. 14, al. 2 et 5)</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">
                Données techniques<br>
                <span class="cell-detail">(Adresse IP, Navigateur, Connexion)</span>
              </div>
              <div class="table-cell">Sécurité de l'application, détection des fraudes, amélioration du service.</div>
              <div class="table-cell">Intérêt légitime (Art. 14, al. 5)</div>
            </div>
          </div>

          <h3 class="subsection-title">3.2. Données des Compagnies de Transport Partenaires</h3>
          <div class="privacy-table data-table">
            <div class="table-row table-header">
              <div class="table-cell">Catégorie de Données</div>
              <div class="table-cell">Finalité du Traitement</div>
              <div class="table-cell">Base Légale</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">
                Données d'identification de l'entreprise<br>
                <span class="cell-detail">(Nom compagnie, Contact, N° compte Wave)</span>
              </div>
              <div class="table-cell">Gestion du partenariat, versement des montants nets des ventes, suivi des transactions.</div>
              <div class="table-cell">Exécution du contrat de partenariat (Art. 14, al. 2)</div>
            </div>
          </div>
        </section>

        <!-- Section 4 -->
        <section class="privacy-section">
          <h2 class="section-title">4. Modalités de Traitement des Paiements (Wave)</h2>
          <p class="section-text">
            UrbanGO utilise la solution de paiement Wave pour fluidifier le processus de transaction.
          </p>
          <p class="section-text">
            UrbanGO ne stocke ni ne traite les informations de paiement sensibles des clients (numéro de carte bancaire complet, cryptogramme, date d'expiration). Ces données sont traitées directement par Wave, qui agit en tant que prestataire de services de paiement et est seul responsable de la sécurité de ces informations.
          </p>
          <p class="section-text">Le rôle d'UrbanGO se limite à :</p>
          <ol class="section-list">
            <li>Transmettre à Wave les informations nécessaires à l'identification de la transaction (montant total, référence).</li>
            <li>Recevoir de Wave la confirmation de paiement et la référence de transaction.</li>
            <li>Utiliser le mécanisme de Wave pour assurer le versement du montant net à la compagnie de transport et le prélèvement automatique des frais de réservation sur le compte d'UrbanGO.</li>
          </ol>
        </section>

        <!-- Section 5 -->
        <section class="privacy-section">
          <h2 class="section-title">5. Destinataires des Données</h2>
          <p class="section-text">Les données collectées sont destinées :</p>
          <ul class="section-list">
            <li><strong>Aux services internes d'UrbanGO</strong> (gestion, comptabilité, technique).</li>
            <li><strong>Aux Compagnies de Transport Partenaires :</strong> Les données d'identification et de voyage du client sont transmises à la compagnie de transport concernée pour l'exécution du contrat de transport (émission du billet et vérification à l'embarquement).</li>
            <li><strong>Au prestataire de paiement Wave :</strong> Pour le traitement sécurisé des transactions financières.</li>
            <li><strong>Aux autorités publiques :</strong> Uniquement en cas d'obligation légale ou de réquisition judiciaire, conformément à la Loi n° 2013-450.</li>
          </ul>
        </section>

        <!-- Section 6 -->
        <section class="privacy-section">
          <h2 class="section-title">6. Transfert de Données Hors de Côte d'Ivoire</h2>
          <p class="section-text">
            Si UrbanGO devait transférer des données à caractère personnel vers un État étranger, ce transfert ne serait effectué qu'à la condition que cet État assure un niveau de protection suffisant de la vie privée et des libertés et droits fondamentaux des personnes, conformément à l'article 43 de la Loi n° 2013-450.
          </p>
        </section>

        <!-- Section 7 -->
        <section class="privacy-section">
          <h2 class="section-title">7. Sécurité et Confidentialité</h2>
          <p class="section-text">
            UrbanGO s'engage à mettre en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité, la confidentialité et l'intégrité des données à caractère personnel collectées, et pour empêcher qu'elles ne soient déformées, endommagées ou que des tiers non autorisés y aient accès (Article 39 et 40 de la Loi n° 2013-450).
          </p>
        </section>

        <!-- Section 8 -->
        <section class="privacy-section">
          <h2 class="section-title">8. Durée de Conservation des Données</h2>
          <p class="section-text">
            Les données à caractère personnel sont conservées pour une durée n'excédant pas celle nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées ou traitées (Article 14, al. 4).
          </p>
          <ul class="section-list">
            <li><strong>Données de réservation et de transaction :</strong> Conservées pendant la durée de la relation contractuelle, augmentée des délais de prescription légale applicables (généralement 5 à 10 ans) à des fins de preuve et de comptabilité.</li>
            <li><strong>Données de prospection commerciale :</strong> Conservées pendant 3 ans à compter du dernier contact avec l'utilisateur, sauf opposition de sa part.</li>
          </ul>
        </section>

        <!-- Section 9 -->
        <section class="privacy-section">
          <h2 class="section-title">9. Droits des Personnes Concernées</h2>
          <p class="section-text">
            Conformément aux articles 28 et suivants de la Loi n° 2013-450, toute personne concernée dispose des droits suivants :
          </p>

          <div class="privacy-table">
            <div class="table-row table-header">
              <div class="table-cell">Droit</div>
              <div class="table-cell">Description</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Droit d'accès</div>
              <div class="table-cell">Obtenir la confirmation que des données vous concernant sont ou non traitées, et en obtenir communication.</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Droit de rectification</div>
              <div class="table-cell">Exiger que les données inexactes, incomplètes ou périmées soient rectifiées, complétées ou mises à jour.</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Droit d'opposition</div>
              <div class="table-cell">S'opposer, pour des motifs légitimes, à ce que des données vous concernant fassent l'objet d'un traitement.</div>
            </div>
            <div class="table-row">
              <div class="table-cell cell-bold">Droit à l'effacement</div>
              <div class="table-cell">Demander l'effacement de vos données, notamment si elles ne sont plus nécessaires au regard des finalités pour lesquelles elles ont été collectées.</div>
            </div>
          </div>

          <!-- Contact Info Box -->
          <div class="contact-box">
            <div class="contact-box__header">
              <v-icon size="20" color="#1e40af" class="mr-2">mdi-email-outline</v-icon>
              <span class="contact-box__title">Pour exercer vos droits</span>
            </div>
            <p class="contact-box__text">
              Adressez une demande écrite et signée, accompagnée d'une copie de votre pièce d'identité, à l'adresse suivante :
            </p>
            <p class="contact-box__text">
              <strong>UrbanGO</strong><br>
              À l'attention de Mohamed FADIGA, Gérant<br>
              Yopougon quartier Maroc, station Pétro Ivoire
            </p>
            <p class="contact-box__text">
              Ou par e-mail à : <strong>[Adresse e-mail pour la confidentialité]</strong>
            </p>
          </div>
        </section>

        <!-- Section 10 -->
        <section class="privacy-section">
          <h2 class="section-title">10. Formalités auprès de l'ARTCI</h2>
          <p class="section-text">
            UrbanGO s'engage à effectuer la déclaration ou, le cas échéant, la demande d'autorisation préalable de ses traitements de données à caractère personnel auprès de l'ARTCI, conformément aux articles 5 et suivants de la Loi n° 2013-450.
          </p>
        </section>

        <!-- Section 11 -->
        <section class="privacy-section">
          <h2 class="section-title">11. Contact et Réclamation</h2>
          <p class="section-text">
            Pour toute question relative à la présente politique ou pour déposer une réclamation, vous pouvez contacter :
          </p>
          <p class="section-text">
            <strong>Le Responsable de Traitement :</strong> Mohamed FADIGA, Gérant d'UrbanGO<br>
            [Adresse e-mail de contact]<br>
            [Numéro de téléphone]
          </p>
          <p class="section-text">
            En cas de désaccord persistant, l'utilisateur a le droit d'introduire une réclamation auprès de l'Autorité de protection, l'ARTCI (Autorité de Régulation des Télécommunications/TIC de Côte d'Ivoire).
          </p>
        </section>

        <!-- References -->
        <div class="references-box">
          <h3 class="references-title">Références</h3>
          <p class="references-text">
            [1] Loi n° 2013-450 du 19 juin 2013 relative à la protection des Données à Caractère Personnel (Consulté via sherloc.unodc.org).
          </p>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'PrivacyPoliciesContent',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    headerStyle() {
      return {
        position: 'fixed',
        top: this.$vuetify.application.top + 'px',
        left: this.$vuetify.application.left + 'px',
        right: this.$vuetify.application.right + 'px',
        zIndex: 5,
      };
    },
    contentStyle() {
      return {
        paddingTop: (this.$vuetify.application.top + 100) + 'px',
      };
    },
  },
};
</script>

<style scoped>
/* Global */
#privacy-policy {
  background: linear-gradient(135deg, #f8fafc 0%, #e8f5f1 100%);
  min-height: 100vh;
}

/* Header */
.privacy-header {
  background: linear-gradient(to right, #159e72 0%, #1e3a8a 100%);
  padding: 1rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.privacy-header__content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.privacy-header__back {
  background: rgba(255, 255, 255, 0.1) !important;
  transition: all 0.2s ease;
}

.privacy-header__back:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: translateX(-2px);
}

.privacy-header__title {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 18px;
  color: white;
  margin: 0;
  line-height: 1.2;
}

.privacy-header__date {
  font-family: "Montserrat";
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  margin: 2px 0 0 0;
  font-style: italic;
}

/* Content */
.privacy-content {
  padding: 40px 24px;
  max-width: 1200px;
}

.privacy-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}

/* Sections */
.privacy-section {
  margin-bottom: 40px;
}

.section-title {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 20px;
  color: #0f172a;
  margin-bottom: 16px;
}

.subsection-title {
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 17px;
  color: #334155;
  margin: 24px 0 16px 0;
}

.section-text {
  font-family: "Montserrat";
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
  margin-bottom: 12px;
  text-align: justify;
}

.section-list {
  font-family: "Montserrat";
  font-size: 14px;
  color: #475569;
  line-height: 1.7;
  margin: 16px 0;
  padding-left: 24px;
}

.section-list li {
  margin-bottom: 8px;
}

/* Tables */
.privacy-table {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  margin: 20px 0;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
}

.table-row:last-child {
  border-bottom: none;
}

.table-header {
  background: #f0fdf4;
}

.table-header .table-cell {
  font-weight: 700;
  color: #0f172a;
}

.table-cell {
  font-family: "Montserrat";
  font-size: 13px;
  color: #475569;
  padding: 14px;
  line-height: 1.5;
  flex: 1;
}

.table-cell:first-child {
  flex: 0 0 35%;
}

.cell-bold {
  font-weight: 600;
  color: #0f172a;
}

.cell-detail {
  font-size: 12px;
  font-weight: 400;
  color: #64748b;
}

/* Data Table (3 columns) */
.data-table .table-cell:nth-child(1) {
  flex: 0 0 30%;
}

.data-table .table-cell:nth-child(2) {
  flex: 0 0 40%;
}

.data-table .table-cell:nth-child(3) {
  flex: 0 0 30%;
}

/* Contact Box */
.contact-box {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 20px;
  margin-top: 24px;
}

.contact-box__header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.contact-box__title {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 15px;
  color: #1e40af;
}

.contact-box__text {
  font-family: "Montserrat";
  font-size: 13px;
  color: #334155;
  line-height: 1.6;
  margin-bottom: 12px;
}

.contact-box__text:last-child {
  margin-bottom: 0;
}

/* References Box */
.references-box {
  background: #f8fafc;
  border-radius: 8px;
  padding: 20px;
  margin-top: 32px;
}

.references-title {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
  margin-bottom: 12px;
}

.references-text {
  font-family: "Montserrat";
  font-size: 12px;
  color: #64748b;
  line-height: 1.6;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .privacy-header {
    padding: 0.75rem 1rem;
  }

  .privacy-header__title {
    font-size: 16px;
  }

  .privacy-header__date {
    font-size: 11px;
  }

  .privacy-card {
    padding: 24px;
  }

  .section-title {
    font-size: 18px;
  }

  .subsection-title {
    font-size: 16px;
  }

  .table-row {
    flex-direction: column;
  }

  .table-cell,
  .data-table .table-cell {
    flex: 1 !important;
  }

  .table-cell:first-child {
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
  }
}
</style>
